import { SettingsParser } from "./settings-parser";
import { FilterSettings } from "../settings/filter-settings";
import { FiltersFactory } from "../../utils/filters-factory";

export class FilterParser extends SettingsParser {
  constructor() {
    super();
  }

  static createFilterInfo(settings) {
    if (settings === undefined) {
      return undefined;
    }
    return {
      name: settings.name,
      filter: FiltersFactory.create(settings)
    };
  }

  parse(settings /*, defaultSettings*/) {
    let filterInfo = FilterParser.createFilterInfo(settings);
    if (filterInfo === undefined) {
      return undefined;
    }
    return new FilterSettings(filterInfo);
  }
}
